import { combineReducers } from 'redux';
import {reducer as formReducer} from 'redux-form';
import {firebaseReducer} from 'react-redux-firebase';
import UserProfile from './reducer_user_profile';
import Poll from './reducer_poll';
import AWSData from './aws_reducer';

const rootReducer = combineReducers({
  form: formReducer,
  firebase: firebaseReducer,
  profile: UserProfile,
  poll: Poll,
  aws: AWSData,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js